
import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';
import { List } from 'vant';
Vue.use(List);
@Component({
  filters: {
    commentTime: (value: any) => {
      return value.substring(0, 10);
    },
  },
})
export default class Message extends Vue {
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  list: any = [];

  onLoad() {
    getList(this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
}
